var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"transparent elevation-0",staticStyle:{"background":"transparent !important"},attrs:{"app":"","padless":""}},[_c('v-col',{staticClass:"text-center caption grey--text py-2",attrs:{"cols":"12"}},[_vm._v(" "+_vm._s(new Date().getFullYear())+" · Bluezone Visitor Management ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }